export class EnrollmentPeriods {
    ID?: number;
    PERIOD?: string;
    DESCRIPTIONS?: string;
    CODE?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
}
